import { SubscriptionApiType } from '../../types/api/SubscriptionApiType';
import { SubscriptionProductViewItem } from './types';
import {
  calculateCouponDiscountBreakdown,
  calculateDisplayShippingPrice,
} from './couponAndShippingEstimate';

// 商品ID関連
const PRODUCT_PFX = 'gid://shopify/Product/';
export const extractProductId = (productId: string) => productId.split(PRODUCT_PFX).pop();
export const toProductGid = (id: string) => PRODUCT_PFX + id;

// プラングループ関連
const PLAN_GROUP_PFX = 'gid://shopify/SellingPlanGroup/';
export const extractPlanGroupId = (planGroupId: string) => planGroupId.split(PLAN_GROUP_PFX).pop();

export function calcTotalSummary(subscribed: SubscriptionProductViewItem[]) {
  let totalQuantity = 0;
  let totalAmount = 0;
  let totalWeight = 0;

  for (const key in subscribed) {
    const productItem = subscribed[key];
    if (!productItem) continue;

    if (productItem.type === 'product') {
      const { quantity, currentPriceAmount, weight } = productItem.product;

      totalQuantity += quantity;
      totalAmount += currentPriceAmount * quantity;
      totalWeight += weight * quantity;
    } else {
      const items = productItem.box.items;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const quantity = item.quantity;
        if (quantity === 0) continue;

        totalQuantity += quantity;
        totalAmount += item.currentPriceAmount * quantity;
        totalWeight += item.weight * quantity;
      }
    }
  }

  return {
    totalQuantity,
    totalAmount,
    totalWeight,
  };
}

export function getBorderPrice(customerTags: string[]) {
  let maxBorderPrice = 50000;
  let minBorderPrice = 2200;
  for (const tag of customerTags) {
    if (tag.startsWith('my_account_limit:')) {
      maxBorderPrice = Number(tag.split(':')[1]) * 10000;
    }

    if (tag.startsWith('my_account_lower_limit:')) {
      minBorderPrice = Number(tag.split(':')[1]);
    }
  }

  return { maxBorderPrice, minBorderPrice };
}

export function isYuPack(totalWeight: number) {
  return totalWeight >= 101;
}

export function checkYuPack(subscribed: SubscriptionProductViewItem[] | null) {
  if (!subscribed) return false;
  const { totalWeight } = calcTotalSummary(subscribed);
  return isYuPack(totalWeight);
}

export function initialSetTotal(subscription: SubscriptionApiType) {
  const { subscriptionLines, subscriptionDiscounts } = subscription;

  let totalPrice = 0;
  let totalQuantity = 0;
  for (const { currentPriceAmount, quantity } of subscriptionLines) {
    totalQuantity += quantity;
    totalPrice += currentPriceAmount * quantity;
  }

  const displayShippingPrice = calculateDisplayShippingPrice(subscription);
  const discountBreakdown = calculateCouponDiscountBreakdown(
    subscription,
    totalPrice,
    displayShippingPrice
  );
  // setTotal 側は従来どおり「商品対象クーポン値引き」を渡す。
  const discountPrice = discountBreakdown.lineItem;
  const effectiveShippingPrice = Math.max(0, displayShippingPrice - discountBreakdown.shippingLine);
  const shippingFree = effectiveShippingPrice === 0;
  const hasShippingCoupon = subscriptionDiscounts.some(
    (discount) => discount.coupon && discount.targetType === 'SHIPPING_LINE'
  );
  // テーマ側の送料カウンターは「送料が無料か」ではなく「表示するか」を別軸で判定する。
  // - 小計 8,000 円以上でも、送料無料クーポン未適用なら「送料無料でお届け！」を表示させたい
  // - 送料無料クーポン適用中は、従来どおりカウンターを非表示にしたい
  const showShippingCounter = !subscription.excludeFromAutoCalculateDeliveryPrice && !hasShippingCoupon;
  const hasUnresolvableCoupon = subscriptionDiscounts.some(
    (discount) =>
      discount.coupon &&
      discount.actualAmount === null &&
      discount.amount === null &&
      discount.percentage === null
  );
  const isCalculating = subscription.isSyncingSubscription && hasUnresolvableCoupon;

  return {
    totalQuantity,
    totalPrice,
    discountPrice,
    shippingFree,
    showShippingCounter,
    isCalculating,
  };
}
